

















import { Component, Vue, Prop } from "vue-property-decorator";
import axios, { resHandle } from "@/plugins/axios";
@Component({})
export default class ObjectSelectSearch extends Vue {
  @Prop()
  private message: any;
  private resultOptions: any[] = [];
  @Prop()
  private type: any;
  @Prop()
  private pl: any;
  private messageChange() {
    this.$emit("update:message", this.message);
  }
  /**
   * @description 获取store中的可编辑状态
   */
  private get composeDisabled() {
    return this.$store.state.researchListComposeDiabled;
  }
  /**
   * @description 搜索
   */
  private fetchOptions(ev) {
    const params: any = {
      params: {
        type: this.type,
        search: ev
      }
    };
    axios.get("api/project/terms", params).then(({ data }) => {
      resHandle(this, data).then(() => {
        this.resultOptions = data.data;
      });
    });
  }
  /**
   * @description 初始化
   */
  private mounted() {
    if (this.message.value) {
      this.resultOptions.push(this.message.value);
      this.$forceUpdate();
    }
  }
}
